import { Col, Row } from "react-bootstrap";
import SiteAreaChart from "../../oversight-core/ui-elements/site-area-chart/site-area-chart";
import Helper from "../../oversight-core/utils/helpers";

interface IProps {
  data: { value: number }[];
  value1?: number;
  value2?: number | string;
  stopColor: string;
  stroke: string;
  isBattery?: boolean;
  batteryStatus?: string;
  id: string;
  hide?: boolean;
}

const SiteEnergySource = (props: IProps) => {
  const {
    data,
    value1,
    value2,
    stopColor,
    stroke,
    id,
    isBattery,
    batteryStatus,
    hide = true,
  } = props;

  return (
    <>
      {isBattery && (
        <Row className="mt-1">
          <Col className="text-light font-weight-400 font-size-8 text-center">
            {batteryStatus}
          </Col>
        </Row>
      )}
      {value1 ? (
        <Row>
          <Col className="text-light font-weight-400 font-size-12 text-center">
            {Number(Helper.roundTo2(value1))}
            {isBattery ? <>%&nbsp;|&nbsp;{value2}</> : <>&nbsp;W</>}
          </Col>
        </Row>
      ) : (
        <></>
      )}
      <SiteAreaChart
        data={data}
        stopColor={stopColor}
        stroke={stroke}
        id={id}
        hide={!value1 && hide}
      />
    </>
  );
};

export default SiteEnergySource;
